import React, { useEffect } from 'react';
import Common from 'us.common';
import {
	General,
	Contact,
	OtherContact,
	Settings,
	Creditors,
	CreditorNotes
} from 'us.collection.creditor/components';
import { BODY_CLASS } from "us.collection/constants";
import './Home.scss';

const { $Row, $Col } = Common.Components;

interface ICnt_CreditorDashBoard {
	caseNo: number;
}
const cnt_CreditorDashboard: React.FC<ICnt_CreditorDashBoard> = (props) => {

  useEffect(() => {
    document.body.classList.add(BODY_CLASS);
    return () => {
      document.body.classList.remove(BODY_CLASS);
    };
  }, []);

	return (
		<div className='creditor-dashboard'>
			<$Row gutter={16}>
				{/* Creditor Basic Info  and Settings*/}
				<$Col
					span={6}
					xxl={{ span: 6 }}
					xl={{ span: 5 }}
					className='gutter-row'>
					<div className='gutter-box pr-xxl-3'>
						<General {...props} />
						<Settings {...props} />
					</div>
				</$Col>

				{/* Creditor Contact Info */}
				<$Col
					span={6}
					xxl={{ span: 6 }}
					xl={{ span: 7 }}
					className='gutter-row'>
					<div className='gutter-box pr-xxl-3'>
						<Contact {...props} />
						<OtherContact {...props} />
					</div>
				</$Col>

				{/* Creditors */}
				<$Col
					span={6}
					xxl={{ span: 6 }}
					xl={{ span: 6 }}
					className='gutter-row'>
					<div className='gutter-box pr-xxl-3'>
						<Creditors {...props} />
					</div>
				</$Col>

				{/* Creditor Notes */}
				<$Col
					span={6}
					xxl={{ span: 6 }}
					xl={{ span: 6 }}
					className='gutter-row'>
					<div className='gutter-box pr-xxl-3'>
						<CreditorNotes entityId={props.caseNo} {...props} />
					</div>
				</$Col>
			</$Row>
		</div>
	);
};
export default cnt_CreditorDashboard;
